import { Navigate, useLocation } from 'react-router';

import { Loader } from '@trendiolive/trendio-selfcare-ui-kit';

// project import
import useSession from 'hooks/useSession';

// types
import { GuardProps } from 'model/types/auth';

// ==============================|| AUTH GUARD ||============================== //

export default function AuthGuard({ children }: Readonly<GuardProps>) {
  const { status } = useSession();
  const location = useLocation();

  switch (status) {
    case 'booting':
    case 'attaching':
      return <Loader />;
    case 'anonymous':
      // Preserve both pathname and query parameters
      return <Navigate to="/login" state={{ from: `${location.pathname}${location.search}` }} replace />;
    case 'merchant-selection':
      return <Navigate to="/merchant-select" replace />;
    case 'active':
      return children;
  }
}
